/**
 * SocialsDropdown Component
 * STANDALONE - Extracted from App.jsx
 */

import { useState, useEffect, useRef } from 'react'
import './SocialsDropdown.css'

const SOCIALS = [
  { name: 'Discord', icon: 'fab fa-discord', color: '#5865F2', url: 'https://discord.gg/9cez8Y7z' },
  { name: 'Twitter', icon: 'fab fa-twitter', color: '#1DA1F2', url: 'https://x.com/ABEThq' },
  { name: 'Instagram', icon: 'fab fa-instagram', color: '#E4405F', url: null },
  { name: 'YouTube', icon: 'fab fa-youtube', color: '#FF0000', url: null },
  { name: 'Telegram', icon: 'fab fa-telegram', color: '#0088cc', url: null },
  { name: 'Email', icon: 'fas fa-envelope', color: '#00B8D4', url: null },
]

function SocialsDropdown() {
  const [isOpen, setIsOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const dropdownRef = useRef(null)

  // Cycle through socials every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % SOCIALS.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const currentSocial = SOCIALS[currentIndex]

  return (
    <div className="socials-dropdown" ref={dropdownRef}>
      <button
        className="socials-toggle"
        onClick={() => setIsOpen(!isOpen)}
        style={{ color: currentSocial.color }}
        title="Social Links"
      >
        <i className={currentSocial.icon}></i>
      </button>

      {isOpen && (
        <div className="socials-menu">
          {SOCIALS.map((social) => (
            social.url ? (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="socials-item"
              >
                <i className={social.icon} style={{ color: social.color }}></i>
                <span>{social.name}</span>
              </a>
            ) : (
              <div
                key={social.name}
                className="socials-item disabled"
              >
                <i className={social.icon} style={{ color: social.color }}></i>
                <span>{social.name}</span>
                <span className="coming-soon-tag">Soon</span>
              </div>
            )
          ))}
        </div>
      )}
    </div>
  )
}

export default SocialsDropdown
